import { VisibleStepMetadata, TableRowMetadata } from "pages/application/applicationService";
import "./Metadata.scss";
import useDesktopChecker from "hooks/useDesktopChecker";
import { GLOBAL_LINK_NO_TX_CLASS } from "utilities/globalLinkNoTx";

const Metadata = ({ metadata }: { metadata: VisibleStepMetadata[] }) => {
  const isDesktop = useDesktopChecker();
  const hasNoTable = Array.isArray(metadata) && metadata[0]?.table == null;
  return (
    <div className={`data ${hasNoTable ? "no-table": ""}`}>
      {metadata.map((item) => (
        <div key={item.text}>
          <div className={`data__label ${hasNoTable ? "no-table": ""}`}>{item.header}</div>
          <div className={`data__values ${GLOBAL_LINK_NO_TX_CLASS}`} data-testid="metadata-value">{item.text}</div>
          {item.table && (
            <div className="data__table">
              {item.table.rows.map((row: TableRowMetadata) => (
                  <div key={row.columns[0]} className="data__table__row">
                    <span className={GLOBAL_LINK_NO_TX_CLASS} data-testid="metadata-table-cell">{row.columns[0]}</span>
                    <span className={`data__table__row__middleColumn ${GLOBAL_LINK_NO_TX_CLASS}`} data-testid="metadata-table-cell"> {row.columns[1]}</span>
                    {(isDesktop || row.columns[2]) &&  <span className={GLOBAL_LINK_NO_TX_CLASS} data-testid="metadata-table-cell"> {row.columns[2]}</span>}
                  </div>
                ))}
            </div>
          )}
          {item.childItems &&
            <ul>
              {item.childItems?.map(({ text }: VisibleStepMetadata) => (
                <li key={text} className={GLOBAL_LINK_NO_TX_CLASS} data-testid="metadata-list-item">{text}</li>
              ))}
            </ul>
          }
        </div>
      ))}
    </div>
  );
};

export default Metadata;
